'use client';

import { memo, useEffect, useState } from 'react';

import { Button } from '@heroui/react';
import { BiArrowToBottom, BiArrowToTop } from 'react-icons/bi';

import { useLocalStorage } from '@/hooks/usePerformance';

import description from './localization/core';

const Description = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [storedExpanded, setStoredExpanded] = useLocalStorage('footer-description-expanded', false);

  useEffect(() => {
    setIsExpanded(storedExpanded);
  }, [storedExpanded]);

  const toggleExpanded = () => {
    const newExpanded = !isExpanded;
    setIsExpanded(newExpanded);
    setStoredExpanded(newExpanded);
  };

  const displayDescription = description.description;

  return (
    <div className="max-w-5xl flex flex-col md:items-center text-wrap pt-4 text-white mt-3 font-text md:pb-12">
      <div className="flex flex-col gap-4 w-full">
        <div className="text-xs relative text-white/90 opacity-50 leading-relaxed px-4">
          <p className={`text-center ${!isExpanded ? 'line-clamp-3' : ''}`}>
            {!isExpanded ? displayDescription.text : displayDescription.longText}
          </p>
          {!isExpanded && <div className="fade-bottom" />}
        </div>
        <div className="flex justify-center -mt-3">
          <Button
            size="sm"
            variant="ghost"
            onPress={toggleExpanded}
            className="bg-gradient-to-tr from-gradient-50 to-gradient-100 text-transparent bg-clip-text text-sm border-b border-gradient-100 px-0 py-0 h-auto min-h-0 leading-tight"
          >
            {isExpanded ? displayDescription.less : displayDescription.more}
            {!isExpanded ? <BiArrowToBottom className="text-sm text-gradient-100" /> : <BiArrowToTop className="text-sm text-gradient-100" />}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(Description);
